app.provider('$bootstrapModal', [function () {
    return {
        $get: ['$rootScope', '$compile', '$controller', '$q', '$templateRequest',
            function ($rootScope, $compile, $controller, $q, $templateRequest) {
                const $modal = {};

                $modal.open = function (modalOptions) {
                    let key;
                    modalOptions = modalOptions ? modalOptions : {};
                    modalOptions.resolve = modalOptions.resolve || {};

                    if (!modalOptions.templateUrl) {
                        throw new Error('templateUrl options are required.');
                    }


                    const bootstrapParams = {
                        backdrop: true,
                        keyboard: true,
                        focus: true,
                        show: true
                    }
                    if (modalOptions.bootstrap_params) {
                        for (key in bootstrapParams) {
                            if (modalOptions.bootstrap_params.hasOwnProperty(key)) {
                                bootstrapParams[key] = !!modalOptions.bootstrap_params[key];
                            }
                        }
                    }

                    $q.all([$templateRequest(modalOptions.templateUrl)]).then(
                        function (response) {
                            const template = response && response.length ? response[0] : null;
                            const body = $("body")
                            let modalDialog = body.children('#BootstrapModalDialog');
                            modalDialog.remove();
                            let modalDialogHTML = '';
                            modalDialogHTML += '<div id="BootstrapModalDialog" class="modal fade" tabindex="-1" role="dialog" >';
                            modalDialogHTML += '<div class="modal-dialog ' + (modalOptions.dialogClass ? modalOptions.dialogClass : '') + '" role="document">';
                            modalDialogHTML += '<div class="modal-content">';
                            modalDialogHTML += template;
                            modalDialogHTML += '</div>';
                            modalDialogHTML += '</div>';
                            modalDialogHTML += '</div>';
                            body.append(modalDialogHTML);
                            modalDialog = body.children('#BootstrapModalDialog').first();

                            const modalScope = (modalOptions.scope || $rootScope).$new();

                            modalScope.$close = function (reason) {
                                modalDialog.modal('hide');
                                modalDialog.remove();
                            }


                            const controller = modalOptions.controller ? modalOptions.controller : "CommonModalSimpleController";
                            const ctrlLocals = {
                                $scope: modalScope
                            };

                            for (key in modalOptions.resolve) {
                                ctrlLocals[key] = modalOptions.resolve[key];
                            }
                            const ctrlInstance = $controller(controller, ctrlLocals);
                            angular.extend(ctrlInstance, modalScope);
                            $compile(modalDialog.contents())(modalScope);


                            modalDialog.modal(bootstrapParams)
                            modalDialog.modal('show');
                        }
                    );
                }
                return $modal;
            }]
    }
}]);
